
import SkillsSection from "components/services/SkillsSection";
import SpecializedSupport from "components/services/SpecializedSupport";
import StafiServices from "components/services/StafiServices";
import FullWidthLayout from "hocs/layouts/FullWidthLayout";

import { connect } from "react-redux";


function Services({

}){



    return(
        <FullWidthLayout>
          <SpecializedSupport/>
          <StafiServices/>
          <SkillsSection/>
        </FullWidthLayout>
    )
}

const mapStateToProps = state =>({

})

export default connect(mapStateToProps,{

})(Services)